<template>
    <div class="column-global-menu">
        <div v-for="(item, index) in model" :key="index" class="group-item">
            <div class="title">{{ item.title }}</div>
            <div v-for="(child, childIndex) in item.children" :key="'child' + childIndex" class="group-item__item" @click="handleItemClick(child, childIndex)">
                <div class="item">{{ child?.getMenuInfo()?.name }}</div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    name: 'ColumnGlobalMenu',
    props: {
        model: [Object, Array]
    },
    data() {
        return {
            //
        }
    },
    created() {
        //
    },
    methods: {
        handleItemClick(item, index) {
            this.SiteMenu.close()
            this.$store.commit('editor/SET_SELECT_WIDGET_ID', item.id)
            this.$store.commit('user/CLEAR_SITE_LOGIN_USER_MODAL')
            this.SiteMenu.setColumnChildIndex(index)
            const model = Object.hasOwn(this.model, '__children') ? this.model : item
            this.$emit('item-click', model, index)
        }
    }
}
</script>

<style lang="less">
.column-global-menu {
    .group-item {
        margin-top: 12px;
        .title {
            font-size: 14px;
            color: white;
            padding-left: 12px;
            font-weight: bold;
            margin-bottom: 8px;
        }

        &__item {
            height: 36px;
            display: flex;
            align-items: center;
            font-size: 12px;
            color: white;
            padding-left: 24px;
            border-radius: @border-radius-base;
            cursor: pointer;
            margin-bottom: 4px;

            &:hover {
                background-color: @fill-color-3;
            }

            &.active {
                background-color: @primary-color-light;
            }
        }
    }
}
</style>
